import { useBranding } from '@/hooks/useTenant';
import { useResolvedTheme } from '@/hooks/useResolvedTheme';
import { resolveBrandLogo } from '@/lib/branding';

export function useBrandLogo(): string {
  const branding = useBranding();
  const theme = useResolvedTheme();
  return resolveBrandLogo(branding, theme);
}
